export const ordersListPath = '/'
export const orderPath = '/order/:orderNumber'
export const authPath = '/auth'
export const legacyAuthPath = '/legacy-auth'
export const createOrderPath = '/order/create'

/** sessionStorage: customer landed on create order via history.replace (e.g. invite); survives refresh, cleared on PUSH to create or logout */
export const createOrderCameViaReplaceStorageKey = 'orders-fe:createOrder:cameViaReplace'
/** sessionStorage: where to return after v3 / external auth (survives query stripping on IdP) */
export const returnAfterAuthStorageKey = 'orders-fe:returnAfterAuth'
/** sessionStorage: last requested orderType on /order/create (survives lost query in auth redirects) */
export const intendedOrderTypeStorageKey = 'orders-fe:intendedOrderType'
export const editOrderPath = '/order/:orderNumber/edit'
export const adminPath = '/admin/:bodyType'
export const searchOrderPath = '/search'
export const monitoring = '/monitoring'
export const invitationPath = '/invitation'
export const statisticPath = '/statistic'
export const billingPath = '/billing'
export const checksPath = '/checks'
export const expertsOnlinePath = '/experts/online'
export const l1OnlinePath = '/l1/online'
export const chatsPath = '/chats'
export const whatWeCheckUrl = 'https://forum.otk.su/t/opisaniya-tipov-proverok'
